(function() {
  $(document).ready(function() {
    var concatAddress, getLatLng, initializeMap, markers, setMarkers, showResults, toRadians;
    markers = {};
    initializeMap = function() {
      var map, mapOptions, styledMap, styles;
      styles = [
        {
          'featureType': 'water',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#d1d1d1'
            }
          ]
        }, {
          'featureType': 'landscape.natural',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#e9e9e9'
            }
          ]
        }, {
          'featureType': 'landscape.man_made',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#eee'
            }
          ]
        }, {
          'featureType': 'road.highway',
          'elementType': 'geometry.fill',
          'stylers': [
            {
              'color': '#ffffff'
            }
          ]
        }, {
          'featureType': 'road.highway',
          'elementType': 'geometry.stroke',
          'stylers': [
            {
              'color': '#ffffff'
            }
          ]
        }, {
          'featureType': 'road.arterial',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#ffffff'
            }
          ]
        }, {
          'featureType': 'road.local',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#ffffff'
            }
          ]
        }, {
          'featureType': 'poi',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#f5f5f5'
            }
          ]
        }, {
          'featureType': 'poi.park',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#dedede'
            }
          ]
        }, {
          'elementType': 'labels.text.fill',
          'stylers': [
            {
              'saturation': 36
            }, {
              'color': '#333333'
            }, {
              'lightness': 40
            }
          ]
        }, {
          'elementType': 'labels.icon',
          'stylers': [
            {
              'visibility': 'off'
            }
          ]
        }, {
          'featureType': 'transit',
          'elementType': 'geometry',
          'stylers': [
            {
              'color': '#f2f2f2'
            }, {
              'lightness': 19
            }
          ]
        }, {
          'featureType': 'administrative',
          'elementType': 'geometry.fill',
          'stylers': [
            {
              'color': '#fefefe'
            }
          ]
        }, {
          'featureType': 'administrative',
          'elementType': 'geometry.stroke',
          'stylers': [
            {
              'color': '#fefefe'
            }
          ]
        }
      ];
      styledMap = new google.maps.StyledMapType(styles, {
        name: 'Styled'
      });
      mapOptions = {
        zoom: 4,
        disableDefaultUI: true,
        scrollwheel: false,
        zoomControl: true,
        disableDoubleClickZoom: true,
        center: new google.maps.LatLng(40.7580184, -73.9791328),
        mapTypeControlOptions: {
          mapTypeIds: [google.maps.MapTypeId.SATELLITE, 'map_style']
        }
      };
      map = new google.maps.Map(document.getElementById('map'), mapOptions);
      map.setTilt(30);
      setMarkers(map, 0);
      map.mapTypes.set('map_style', styledMap);
      return map.setMapTypeId('map_style');
    };
    setMarkers = function(map, index) {
      var address, lat, lng, marker, myLatlng, storeAddresses, title;
      storeAddresses = $('.hidden-locations .store-address');
      address = concatAddress($(storeAddresses[index]));
      title = $('.store-title')[index].innerHTML;
      if ($('.lat')[index] !== void 0 && $('.lng')[index] !== void 0) {
        lat = $('.lat')[index].innerHTML;
        lng = $('.lng')[index].innerHTML;
        myLatlng = new google.maps.LatLng(lat, lng);
        marker = new google.maps.Marker({
          position: myLatlng,
          map: map,
          title: title,
          type: 'rect'
        });
        location["index"] = index;
        markers[index] = location;
      }
      if (index < (storeAddresses.length - 1)) {
        return setMarkers(map, index + 1);
      }
    };
    concatAddress = function($address) {
      var address_1, address_2, address_3;
      address_1 = $address.find('.address_1').length ? ($address.find('.address_1').text()) + "+" : '';
      address_2 = $address.find('.address_2').length ? ($address.find('.address_2').text()) + "+" : '';
      address_3 = $address.find('.address_3').length ? $address.find('.address_3').text() : '';
      return "" + (address_1.split(' ').join('+')) + (address_2.split(' ').join('+')) + (address_3.split(' ').join('+'));
    };
    getLatLng = function(zipCode, radius) {
      var getAddress;
      getAddress = $.get("https://maps.googleapis.com/maps/api/geocode/json?address=" + zipCode + "&key=AIzaSyASHadPh9_xniFdaviUKFSomkB3H9ncYMU");
      console.log('getlatlng');
      return getAddress.then(function(data) {
        var lat, lng;
        if (data.results.length) {
          lat = data.results[0].geometry.location.lat;
          lng = data.results[0].geometry.location.lng;
          return {
            lat: lat,
            lng: lng,
            radius: radius
          };
        } else {
          return false;
        }
      });
    };
    showResults = function(results) {
      var $row, $searchResults, articleHtml, firstCol, firstIndex, i, j, len, result, results1, secondCol, secondIndex;
      $('.results-count').text(results.length);
      $('.zip-searched').text("“" + ($('#addressInput').val()) + "”");
      $('.zip-search-results').removeClass('hidden');
      $('.default-header').addClass('hidden');
      articleHtml = [];
      $searchResults = $('.search-result-locations');
      if (results.length > 0) {
        $('.featured').not('.featured-1').addClass('hidden');
        results1 = [];
        for (i = j = 0, len = results.length; j < len; i = j += 2) {
          result = results[i];
          $row = $('<div>').addClass('row');
          firstIndex = results[i].index;
          firstCol = $($(".hidden-locations .article-post")[firstIndex]).clone();
          $row.append(firstCol);
          if (results[i + 1]) {
            secondIndex = results[i + 1].index;
            secondCol = $($(".hidden-locations .article-post")[secondIndex]).clone();
            $row.append(secondCol);
          }
          $searchResults.append($row);
          if (Math.abs(i + 1 - results.length) <= 1) {
            $('.search-result-locations').removeClass('hidden');
            results1.push($('.retail-map--wrapper .background, .retail-map--wrapper .retail-map--form').addClass('hidden'));
          } else {
            results1.push(void 0);
          }
        }
        return results1;
      } else {
        $('.featured').removeClass('hidden');
        return $('.search-result-locations').empty().addClass('hidden');
      }
    };
    toRadians = function(number) {
      return number * Math.PI / 180;
    };
    if ($('#store-locator').length) {
      return initializeMap();
    }
  });

}).call(this);
